import React from 'react'
import StaticOverviewPage from "./StaticOverviewPage"

function StaticOverviewContainer(props) {
    return (
        <div className='StaticOverviewContainer'>
            <StaticOverviewPage/>
        </div>
    )
}

export default StaticOverviewContainer
